import { api } from "@/api/client";

export interface UsageDay {
  day: string;                // 'YYYY-MM-DD'
  endpoint: string;
  calls: number;
  credits: number;
  avg_latency_ms: number;
}

export interface UsageHour {
  hour: string;               // ISO of hour-bucket start
  endpoint: string;
  calls: number;
  credits: number;
  avg_latency_ms: number;
}

export interface UsageByIp {
  ip: string;
  country: string;
  calls: number;
  credits: number;
}

export interface CurrentCycleUsage {
  used: number;
  limit: number;
  cycle_days: number;
  cycle_start: string;   // ISO
  resets_at: string;     // ISO of paid_until
}

export interface SseUsage {
  window_start: string;          // ISO
  window_end: string;            // ISO
  connections_opened: number;
  unique_ips: number;
  unique_countries: number;
  // Estimated from closed sessions only. In-flight connections (still
  // open at query time) aren't in usage_events yet, so this undercounts
  // for windows that include currently-active streams.
  concurrent_peak: number;
  concurrent_peak_at: string | null;
}

export interface SseSeriesPoint {
  bucket: string;                // ISO of bucket start (connect-time side)
  connections: number;
  unique_ips: number;
}

export const usageApi = {
  daily: (pid: string, params: { from?: string; to?: string; api_key_id?: string } = {}) =>
    api.get<{ rows: UsageDay[]; total_credits: number }>(`/projects/${pid}/usage`, { query: params }),
  hourly: (pid: string, params: { from?: string; to?: string; api_key_id?: string } = {}) =>
    api.get<{ rows: UsageHour[]; total_credits: number }>(`/projects/${pid}/usage/hourly`, { query: params }),
  byIp: (pid: string, params: { from?: string; to?: string; api_key_id?: string; limit?: number } = {}) =>
    api.get<UsageByIp[]>(`/projects/${pid}/usage/by-ip`, { query: params }),
  sse: (pid: string, params: { from?: string; to?: string; api_key_id?: string } = {}) =>
    api.get<SseUsage>(`/projects/${pid}/usage/sse`, { query: params }),
  sseSeries: (
    pid: string,
    params: { from?: string; to?: string; api_key_id?: string; granularity?: "hour" | "day" } = {},
  ) => api.get<SseSeriesPoint[]>(`/projects/${pid}/usage/sse/series`, { query: params }),
  currentCycle: (pid: string) =>
    api.get<CurrentCycleUsage>(`/projects/${pid}/usage/current-cycle`),
};
